<div class="footer-btn-wrapper">
  <g99-button
    *ngIf="showResetBtn"
    width="100%"
    variant="medium"
    color="transparent"
    [disabled]="!isFormDirty || isFormSubmitting"
    (buttonClick)="resetForm.emit()"
    ><span [innerHTML]="trustedIcon"></span>{{ resetBtnLabel }}
  </g99-button>

  <g99-button
    *ngIf="showCancelBtn"
    variant="medium"
    color="transparent"
    [class.active]="isFormDirty"
    (buttonClick)="cancelForm.emit()"
  >
    Cancel
  </g99-button>
  <g99-button
    type="button"
    padding="8px 30px"
    [color]="'secondary'"
    [ngClass]="{ primary: saveBtnColor, active: isFormValid && isFormDirty }"
    [disabled]="!isFormValid || !isFormDirty || isFormSubmitting"
    [loadingText]="saveBtnLoadingText"
    [isLoading]="isFormSubmitting"
    (buttonClick)="saveForm.emit()"
  >
    {{ saveBtnLabel }}
  </g99-button>
</div>
